import {
  faBadgeCheck,
  faBasketShopping,
} from "@fortawesome/pro-light-svg-icons";
import { faSquareUpRight } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BasketButton from "./BasketButton";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { updateBasket } from "../../features/basket/basketSlice";
import { useSelector } from "react-redux";
import Button from "../../components/ui/Button";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import FieldError from "../../components/ui/FieldError";
import { Controller } from "react-hook-form";
import RequiredField from "../../components/ui/RequiredField";
import SelectPartnerLogisticAddress from "../../components/ui/Selects/PartnerLogisticAddress";
import axiosConfig from "../../services/Axios";

const BasketInformation = ({ basket }) => {
  const [basketSended, setBasketSended] = useState(null);
  const authUser = useSelector((state) => state.auth);
  const [counter, setCounter] = useState(5);
  const [partner, setPartner] = useState(null);
  const { t } = useTranslation();
  let navigate = useNavigate();

  const form = useForm();
  const dispatch = useDispatch();

  const loadPartner = () => {
    axiosConfig
      .get(process.env.REACT_APP_API_URL + authUser?.user?.partner)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setPartner(response.data);
        }
      });
  };

  useEffect(() => {
    if (!partner) {
      loadPartner();
    }
  }, []);

  useEffect(() => {
    if (basketSended) {
      let newCounter = counter;
      const intervalId = setInterval(() => {
        newCounter = newCounter - 1;
        setCounter(newCounter);
        if (newCounter === 0) {
          navigate("/settings/orders/" + basketSended, { replace: false });
        }
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [basketSended]);

  const onSubmit = async (data) => {
    dispatch(
      updateBasket({
        data: { state: "awaiting", deliveryAddress: data.deliveryAddress },
        basket: authUser.user.order,
      })
    ).then((e) => {
      if (e?.payload?.response?.data?.violations) {
        e.payload.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      } else {
        form.reset();
        setBasketSended(e.payload.id);
      }
    });
  };

  return (
    <div className="scroll-auto p-4">
      {basketSended ? (
        <div className="text-center">
          <FontAwesomeIcon
            icon={faBadgeCheck}
            className="text-7xl text-green-400 mb-4"
          />
          <p className="font-bold mb-1 text-sm ">
            {t("shop.basket.awaiting_basket")}
          </p>
          <p className="text-sm">{t("shop.basket.awaiting_basket_mail")}</p>
          <p className="text-center text-xs mt-2">
            {t("shop.basket.redirect", { counter: counter })}
          </p>
          <div className="mt-8">
            <Link
              to={"/settings/orders/" + basketSended}
              className="rounded-md bg-bioport-blue hover:bg-bioport-orange text-white px-4 py-2"
            >
              <FontAwesomeIcon icon={faSquareUpRight} className="mr-2" />
              {t("shop.basket.orderLink")}
            </Link>
          </div>
        </div>
      ) : basket && basket.entities?.length > 0 ? (
        <>
          <div className="grid grid-cols-12 font-bold py-2 border-b-2 border-bioport-blue">
            <div className="col-span-6 lg:col-span-9 text-left lg:ml-7">
              {t("shop.basket.basketItem")}
            </div>
            <div className="col-span-6 lg:col-span-3 text-right lg:text-center">
              {t("shop.basket.basketItemQuantity")}
            </div>
          </div>

          <div>
            {basket.entities?.map((orderItem, key) => (
              <div
                className={`grid grid-cols-12 border-t py-3 items-center ${
                  key % 2 === 0 && "bg-gray-50"
                }`}
                key={key}
              >
                <div
                  className={`col-span-6 lg:col-span-9 text-left text-sm pl-2 lg:pl-7 items-center`}
                >
                  {orderItem.item.name}
                </div>
                {basket.state === "in_progress" ? (
                  <div className="col-span-6 lg:col-span-3 text-center">
                    <BasketButton
                      formParent={form}
                      item={orderItem.item}
                      isloading={basket.loading}
                      className="m-auto justify-end pr-2"
                    />
                  </div>
                ) : (
                  <div className="col-span-6 lg:col-span-3 text-sm py-2 font-bold text-center">
                    {orderItem.quantity}
                  </div>
                )}
              </div>
            ))}
            <FieldError error={form.formState?.errors?.purchaseOrderItems} />
          </div>

          <div className="border-t-2 border-bioport-blue">
            <form onSubmit={form.handleSubmit(onSubmit)} className="">
              <div className="col-span-12 mt-4">
                <label>
                  {t("shop.basket.partnerLogisticAddress")} <RequiredField /> :
                </label>
                <div className="p-4 px-5 rounded-lg bg-gray-100">
                  <Controller
                    control={form.control}
                    name="deliveryAddress"
                    rules={{ required: t("shop.basket.address_needed") }}
                    render={({ field: { onChange, ref } }) => (
                      <SelectPartnerLogisticAddress
                        onChange={onChange}
                        inputRef={ref}
                        className={"py-1"}
                        isClearable={false}
                        partner={authUser?.user?.partner}
                        emptyOpt={false}
                        setValue={(v) => form.setValue("deliveryAddress", v)}
                        aria-invalid={
                          form.formState?.errors?.deliveryAddress ? true : false
                        }
                      />
                    )}
                  />
                  <FieldError error={form.formState?.errors?.deliveryAddress} />
                </div>
              </div>
              <div className="text-center lg:text-right">
                <Button
                  className="font-bold py-5 btn btn-primary mt-6"
                  isloading={basket.loading}
                >
                  {t("shop.basket.confirm_basket")}
                </Button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <div className="text-center justify-end py-8">
          <div>
            <FontAwesomeIcon
              icon={faBasketShopping}
              className="text-6xl text-bioport-orange"
            />
          </div>
          <div className="mt-6">{t("shop.basket.empty_basket")}</div>
        </div>
      )}
    </div>
  );
};

export default BasketInformation;
